import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface LanguageRequest {
  languageId?: number;
  code: string;
  name: string;
  icon?: File;
  isEnabled: boolean;
}


@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private apiUrl = environment.apiBaseUrl + '/api/language';

  constructor(private http: HttpClient) { }

  getAll(): Observable<any> {
    return this.http.get(this.apiUrl);
  }

  getById(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`);
  }

  create(request: LanguageRequest): Observable<any> {

    const formData = new FormData();

    formData.append('Code', request.code);
    formData.append('Name', request.name);
    formData.append('IsEnabled', request.isEnabled.toString());

    if (request.icon) {
      formData.append('Icon', request.icon);
    }

    return this.http.post(this.apiUrl, formData);
  }

  update(request: LanguageRequest): Observable<any> {

    const formData = new FormData();

    formData.append('LanguageId', request.languageId!.toString());
    formData.append('Code', request.code);
    formData.append('Name', request.name);
    formData.append('IsEnabled', request.isEnabled.toString());

    if (request.icon) {
      formData.append('Icon', request.icon);
    }

    return this.http.put(`${this.apiUrl}/${request.languageId}`, formData);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
  

}